var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "reply"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3137_52071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3137_52071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "reply_2",
    d: "M16.1907 16.6909V13.9976C16.1907 13.6181 16.0611 13.2988 15.802 13.0396C15.5428 12.7805 15.2235 12.6509 14.844 12.6509H10.3181L11.998 14.3308L10.7762 15.5525L7 11.7762L10.7762 8L11.998 9.22173L10.3181 10.9016H14.844C15.6955 10.9016 16.4244 11.2047 17.0306 11.811C17.6369 12.4172 17.94 13.1461 17.94 13.9976V16.6909H16.1907Z",
    fill: "#4CAF50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyReceived);
export default __webpack_public_path__ + "static/media/reply-received.3acc0cef070041a413a29503140a026b.svg";
export { ForwardRef as ReactComponent };